function CartReload(data) {
  var container = document.getElementById('cart-table')
  var tT = document.getElementById('total-top');
  var c = document.querySelector('.cart-table');
  var tB = document.getElementById('total-bottom');
  const parser = new DOMParser();
  const htmlDocument = parser.parseFromString(data, 'text/html');
  var nTT = htmlDocument.documentElement.querySelector('#total-top');
  var nC = htmlDocument.documentElement.querySelector('.cart-table');
  var nTB = htmlDocument.documentElement.querySelector('#total-bottom');
  tT.replaceWith(nTT);
  c.replaceWith(nC);
  tB.replaceWith(nTB);  
  container.querySelector('.full-form').classList.remove('hidden');
  container.querySelector('.empty-form').classList.add('hidden');
  // Quantity(container); // REMOVED: Conflicts with NPO cart handlers
  CartButtons();
  
  // 🔧 NPO FIX: Update restriction notices after cart reload
  // The cart reload replaces HTML content, so we need to refresh restriction data
  if (typeof window.updateCartRestrictionNotices === 'function') {
    setTimeout(window.updateCartRestrictionNotices, 200);
  }
}

// Prevent duplicate CartChange calls (wrapped in IIFE to prevent global conflicts)
(function() {
  'use strict';
  
  let cartChangeInProgress = false;
  
  // Make CartChange function available globally
  window.CartChange = CartChange;
  
  function getCartChangeInProgress() {
    return cartChangeInProgress;
  }
  
  function setCartChangeInProgress(value) {
    cartChangeInProgress = value;
  }
  
  // Expose the control functions globally for other scripts
  window.getCartChangeInProgress = getCartChangeInProgress;
  window.setCartChangeInProgress = setCartChangeInProgress;
  window.CartButtons = CartButtons;

  // Recovery function for cart update failures
  function attemptCartUpdateRecovery(correctKey, newQuantity) {
    console.log(`[CartChange Recovery] Attempting update with correct key: ${correctKey}, quantity: ${newQuantity}`);
    
    fetch(theme.routes_cart_change_url + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({'quantity': newQuantity, 'id': correctKey})
    }).then(function(r) {
      if (!r.ok) {
        console.error(`[CartChange Recovery] Still failed with correct key: ${r.status} ${r.statusText}`);
        // Final fallback - reload the page
        console.log(`[CartChange Recovery] Final fallback: reloading page`);
        window.location.reload();
        return;
      }
      return r.json();
    }).then(function(j) {
      if (j && j.total_price !== undefined) {
        console.log(`[CartChange Recovery] ✅ Success! Cart updated with recovery method`);
        // Reload the page to ensure everything is synced
        window.location.reload();
      }
    }).catch(function(err) {
      console.error(`[CartChange Recovery] Final error:`, err);
      window.location.reload();
    }).finally(() => {
      setCartChangeInProgress(false);
    });
  }

function CartChange(q,container) {
  // Prevent duplicate calls
  if (getCartChangeInProgress()) {
    console.log(`[CartChange] Already in progress, skipping duplicate call`);
    return;
  }
  
  var header = document.querySelector('header');
  var it = q.closest('.item');
  var id = it.getAttribute('data-product-id');
  var currentQuantity = it.querySelector('.item-qty').value;
  var iQ = it.querySelector('.item-qty');
  var s = it.querySelector('.error');
  var rct = container.getAttribute('data-recent');
  
  // Check if this is an unrestricted item and validate inventory first
  const isRestricted = iQ.hasAttribute('data-npo-restricted') && iQ.getAttribute('data-npo-restricted') === 'true';
  
  if (!isRestricted) {
    console.log(`[CartChange] 📦 Unrestricted item detected - checking inventory limits`);
    
    const maxInventory = parseInt(iQ.getAttribute('max'), 10);
    const currentValue = parseInt(currentQuantity, 10) || 0;
    
    console.log(`[CartChange] Inventory check - Current: ${currentValue}, Max: ${maxInventory}, Has Max: ${!!maxInventory}`);
    
          if (maxInventory && maxInventory > 0 && currentValue > maxInventory) {
        console.log(`[CartChange] 🛑 Inventory limit exceeded - showing popup and correcting quantity`);
        
        // Set quantity to max available
        iQ.value = maxInventory;
        currentQuantity = maxInventory.toString();
        
        // Show inventory limit message using theme's language
        if (s) {
          s.style.display = 'block';
          const msg1 = theme.language?.products_general_inv_msg_1 || 'Only';
          const msg2 = theme.language?.products_general_inv_msg_2 || 'left in stock';
          s.innerHTML = msg1 + '&nbsp;' + maxInventory + '&nbsp;' + msg2;
          console.log(`[CartChange] 📦 Showing inventory message: "${msg1} ${maxInventory} ${msg2}"`);
          
          // Hide the message after 4 seconds
          setTimeout(() => {
            if (s) {
              s.style.display = 'none';
            }
          }, 4000);
        }
        
        // Mark this as an inventory correction
        isInventoryCorrection = true;
        
        // Check if we actually need to update the cart or if it's already at the correct quantity
        const currentCartQuantity = parseInt(iQ.getAttribute('value'), 10) || 0;
        if (currentCartQuantity === maxInventory) {
          console.log(`[CartChange] ⏹️ Cart already has correct quantity (${maxInventory}) - showing popup only, no API call`);
          setCartChangeInProgress(false);
          return;
        }
        
                console.log(`[CartChange] 🔄 Proceeding with inventory correction sync to cart`);
      } else if (maxInventory && maxInventory > 0 && currentValue === maxInventory) {
        // User is trying to set quantity to exactly the max - this is fine, proceed normally
        console.log(`[CartChange] ✅ Setting quantity to max inventory (${maxInventory}) - normal update`);
      }
      
      // If we had to correct the quantity due to inventory limits, check if we should skip the API call
      if (maxInventory && maxInventory > 0) {
        const correctedQuantity = parseInt(currentQuantity, 10);
        const originalQuantity = parseInt(iQ.getAttribute('value'), 10) || correctedQuantity;
        
        // If we corrected the quantity from a higher value to max, and it's just a display correction
        if (correctedQuantity === maxInventory && originalQuantity > maxInventory) {
          console.log(`[CartChange] ⏹️ Quantity corrected to inventory limit (${maxInventory}) - proceeding with API call to sync`);
          // Continue with the API call to sync the corrected quantity
        }
      }
  } else {
    console.log(`[CartChange] 🔐 Restricted item detected - using NPO validation`);
  }
  
  setCartChangeInProgress(true);
  
  // Track if this is just an inventory limit correction
  let isInventoryCorrection = false;
  
  var aB = document.getElementById('ajaxBusy');
  var cTa = document.getElementById('cart-table');
  var cC = document.querySelectorAll('.cartCountSelector');
  var cT = document.querySelector('.cartTotalSelector');
  var tT = document.getElementById('total-cart-top');
  var c = document.querySelector('.cart-table');
  var tC = document.getElementById('cart-total');
  var tB = document.getElementById('total-cart-bottom');
  var dC = document.querySelector('.discount-cart');
  var aS = document.querySelector('.animate-section'); 
  var cD = document.getElementById('cart-dropdown');
  if (currentQuantity != '') {
    aB.style.display = 'block';
  }
  
  // Validate and prepare the payload
  const quantity = parseInt(currentQuantity);
  
  // Validate inputs
  if (isNaN(quantity) || quantity < 0) {
    console.error(`[CartChange] Invalid quantity: ${currentQuantity}`);
    setCartChangeInProgress(false);
    return;
  }
  
  if (!id || typeof id !== 'string') {
    console.error(`[CartChange] Invalid line item ID: ${id}`);
    setCartChangeInProgress(false);
    return;
  }
  
  // Check if this line item has properties (contains colon)
  const hasProperties = id.includes(':');
  if (hasProperties) {
    console.log(`[CartChange] ⚠️ Line item has properties: ${id}`);
    console.log(`[CartChange] This may cause 422 errors - monitoring for recovery`);
  }
  
  const payload = {'quantity': quantity, 'id': id};
  console.log(`[CartChange] Updating cart - Line Item ID: ${id}, Quantity: ${quantity}`);
  console.log(`[CartChange] Has Properties: ${hasProperties}`);
  console.log(`[CartChange] Payload:`, payload);
  
  fetch(theme.routes_cart_change_url + '.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  }).then(function(r) {
    // Handle non-200 responses properly
    if (!r.ok) {
      console.error(`[CartChange] API Error: ${r.status} ${r.statusText}`);
      if (r.status === 422) {
        console.error(`[CartChange] 422 Validation Error - This usually means:`);
        console.error(`- Line item ID format is invalid: "${id}"`);
        console.error(`- Quantity is invalid: ${quantity}`);
        console.error(`- Item no longer exists in cart`);
        console.error(`- Line item properties conflict`);
        // Try to reload cart to get fresh data
        console.log(`[CartChange] Attempting cart reload to recover from 422 error`);
        window.location.reload();
        return;
      }
      throw new Error(`HTTP ${r.status}: ${r.statusText}`);
    }
    return r.json();
  }).then(function(j) {
    console.log(`[CartChange] API response:`, j);
    
    // Check for valid API response
    if (!j || j.total_price === undefined) {
      console.error(`[CartChange] Invalid API response, aborting update`);
      cartChangeInProgress = false;
      return;
    }
    
    // 🔧 FIX: For NPO restricted products, always reload to ensure perfect sync
    const isNpoRestricted = iQ && iQ.getAttribute('data-npo-restricted') === 'true';
    if (isNpoRestricted) {
      console.log(`[CartChange] NPO restricted product detected, reloading page for perfect sync`);
      setCartChangeInProgress(false);
      window.location.reload();
      return;
    }
    if (currentQuantity != '') {
      cC.forEach(function(c) {
        c.textContent = j.item_count;
      });
      if (header) {
        const formattedTotal = Shopify.formatMoney(j.total_price, theme.moneyFormat).replace(/((\,00)|(\.00))$/g, '');
        console.log(`[CartChange] Updating cart totals to: ${formattedTotal} (raw: ${j.total_price})`);
        cT.innerHTML = formattedTotal;
        tT.innerHTML = formattedTotal;
      }
      if(j.cart_level_discount_applications && j.cart_level_discount_applications.length > 0) {
        tC.innerHTML = Shopify.formatMoney(j.items_subtotal_price, theme.moneyFormat).replace(/((\,00)|(\.00))$/g, '');
        dC.innerHTML = Shopify.formatMoney('-' + j.total_discount, theme.moneyFormat).replace(/((\,00)|(\.00))$/g, '');
      }
      tB.innerHTML = Shopify.formatMoney(j.total_price, theme.moneyFormat).replace(/((\,00)|(\.00))$/g, '');
    }    
    if (j.item_count == 0) {
      cTa.querySelector('.full-form').classList.add('hidden');
      cTa.querySelector('.empty-form').classList.remove('hidden');
      aB.style.display = 'none';
      if (theme.dropdown == true) {
        document.querySelector('.cart-count-mobile').setAttribute('href', theme.routes_cart_url);
        document.querySelector('.cart-count-mobile').classList.remove('void');
      }
      if (cD) {
        cD.remove();
      }
      if(rct == 'true' && aS){
        document.querySelector('.animate-section').classList.add('go','up');
      };
    } else {
      var x = theme.cart;
      CartDrop(x);
      
      // For inventory corrections, skip the cart reload to preserve the popup
      if (isInventoryCorrection) {
        console.log(`[CartChange] ✅ Inventory correction complete - skipping reload to preserve popup`);
        if (aB) {
          aB.style.display = 'none';
        }
        setCartChangeInProgress(false);
        return;
      }
      
      fetch(theme.routes_cart_url)
      .then(response => response.text())
      .then(data => {
        if (currentQuantity != '') {
          if (currentQuantity == 0) {
            it.remove();
          }
          console.log(`[CartChange] Reloading cart with fresh data`);
          CartReload(data)
          aB.style.display = 'none';
        }
        imageObserver();
        setCartChangeInProgress(false); // Reset flag when complete
      }).catch(function(err) {
        console.error('!: ' + err)
        setCartChangeInProgress(false); // Reset flag on error
      });
    }
  }).catch(function(err) {
    console.error(`[CartChange] Request failed:`, err);
    setCartChangeInProgress(false); // Reset flag on API error
    
    // Show user-friendly error for common issues
    if (err.message.includes('422')) {
      console.error(`[CartChange] 422 Error Details:`);
      console.error(`- Line Item ID: "${id}"`);
      console.error(`- Quantity: "${currentQuantity}"`);
      console.error(`- Input element:`, iQ);
      console.error(`- Item container:`, it);
      
             // Log current cart data for debugging and attempt recovery
       console.error(`[CartChange] Starting cart diagnostics...`);
       fetch('/cart.js')
         .then(r => r.json())
         .then(cartData => {
           console.error(`[CartChange] Current cart items for debugging:`, cartData.items);
           console.error(`[CartChange] Looking for item with key: "${id}"`);
           
           const matchingItem = cartData.items.find(item => item.key === id);
           if (matchingItem) {
             console.error(`[CartChange] Found matching item:`, matchingItem);
           } else {
             console.error(`[CartChange] No matching item found with exact key!`);
             console.error(`[CartChange] Available keys:`, cartData.items.map(item => ({key: item.key, variant_id: item.variant_id, quantity: item.quantity})));
             
             // Try to find by variant ID (extract from key format)
             const variantIdFromKey = id.split(':')[0]; // Get part before colon
             const itemByVariant = cartData.items.find(item => item.variant_id.toString() === variantIdFromKey);
             
             if (itemByVariant) {
               console.error(`[CartChange] Found item by variant ID: ${variantIdFromKey}`, itemByVariant);
               console.error(`[CartChange] Attempting recovery with correct key: ${itemByVariant.key}`);
               
               // Retry with the correct key
               attemptCartUpdateRecovery(itemByVariant.key, quantity);
               return;
             }
           }
         })
         .catch(cartErr => {
           console.error(`[CartChange] Failed to fetch cart data for debugging:`, cartErr);
         });
    }
    
    // Hide loading indicator
    if (aB) {
      aB.style.display = 'none';
    }
  });
}

/**
 * Validates a quantity change using the cart protection system
 * @param {string} productId - The product ID
 * @param {number} newQuantity - The new quantity
 * @param {number} currentQuantity - The current quantity
 * @returns {Promise<Object>} - { allowed: boolean, reason: string, message?: string }
 */
async function validateQuantityChange(productId, newQuantity, currentQuantity) {
  // If cart protection system is available, use it
  if (window.cartProtectionManager?.validateQuantityChange) {
    return await window.cartProtectionManager.validateQuantityChange(productId, newQuantity, currentQuantity);
  }
  
  // Otherwise, allow the change (fail open)
  console.log(`[Cart] Cart protection system not available, allowing change`);
  return { allowed: true, reason: 'no-protection-system' };
}

/**
 * Shows a toast notification using the cart protection system
 * @param {string} message - The message to display
 * @param {string} type - The type of notification
 */
function showToastNotification(message, type = 'error') {
  // If cart protection system is available, use it
  if (window.cartProtectionManager?.showToastNotification) {
    window.cartProtectionManager.showToastNotification(message, type);
  } else {
    // Fallback: just log to console
    console.log(`[Cart] Toast notification: ${message} (${type})`);
  }
}

function CartButtons() {
  var container = document.getElementById('cart-table'),
      qB = container.querySelectorAll('.qtybtn');
  
  // Add debounce mechanism to prevent rapid clicks
  let lastClickTime = 0;
  const clickDebounceMs = 500; // 500ms between clicks
  
  qB.forEach(function(q) {
    // Check if this is an NPO restricted product
    var quantityForm = q.closest('.quantity.form');
    var quantityInput = quantityForm ? quantityForm.querySelector('.item-qty') : null;
    var isNpoRestricted = quantityInput && quantityInput.getAttribute('data-npo-restricted') === 'true';
    
    if (q.classList.contains('icon-plus')) {
      var qF = q.closest('.quantity.form'),
          vV = qF.querySelector('.item-qty').value,
          vM = qF.querySelector('.item-qty').getAttribute('max');
    }
    
    setTimeout(function () {
      q.onclick = async function(ev){
        // Debounce rapid clicks
        const now = Date.now();
        if (now - lastClickTime < clickDebounceMs) {
          ev.preventDefault();
          ev.stopPropagation();
          return false;
        }
        lastClickTime = now;
        
        // Handle remove buttons separately (they don't have .quantity.form structure)
        if (q.classList.contains('remove_item_multi')) {
          // Find the quantity input in the same item and set it to 0
          var item = q.closest('.item');
          var quantityInput = item ? item.querySelector('.item-qty') : null;
          
          if (quantityInput) {
            quantityInput.value = 0;
          }
          
          ev.preventDefault();
          ev.stopPropagation();
          CartChange(q, container);
          return false;
        }
        
        // Get the quantity input for this button (plus/minus buttons only)
        var quantityInput = q.closest('.quantity.form').querySelector('.item-qty');
        if (!quantityInput) {
          return;
        }
        
        var currentQuantity = parseInt(quantityInput.value, 10) || 0;
        var newQuantity = currentQuantity;
        
        // Calculate new quantity based on button type
        if (q.classList.contains('icon-plus')) {
          newQuantity = currentQuantity + 1;
        } else if (q.classList.contains('icon-minus')) {
          newQuantity = Math.max(0, currentQuantity - 1);
        }
        
        // For NPO restricted products, validate BEFORE allowing cart change
        if (isNpoRestricted) {
          console.log(`[Cart] NPO restricted product - validating before cart change`);
          
          const productId = quantityInput.getAttribute('data-product-id');
          const validationResult = await validateQuantityChange(productId, newQuantity, currentQuantity);
          
          if (!validationResult.allowed) {
            console.log(`[Cart] BLOCKED - ${validationResult.reason}`);
            if (validationResult.message) {
              // Show different toast types based on the reason
              const toastType = validationResult.reason === 'fallback-allowed' ? 'info' : 'warning';
              showToastNotification(validationResult.message, toastType);
            }
            ev.preventDefault();
            ev.stopPropagation();
            return false;
          }
          
          console.log(`[Cart] NPO validation passed - proceeding with cart change`);
        }
        
        // Enhanced inventory validation for unrestricted products
        if (!isNpoRestricted && q.classList.contains('icon-plus')) {
          const maxInventory = parseInt(quantityInput.getAttribute('max'), 10);
          
          if (maxInventory && maxInventory > 0) {
            if (newQuantity > maxInventory) {
              console.log(`[Cart] 🛑 Plus button blocked - inventory limit reached (${maxInventory})`);
              
              // Set to max available and show message
              quantityInput.value = maxInventory;
              
              // Find and show the error message
              const errorElement = document.getElementById(quantityInput.getAttribute('field'));
              if (errorElement) {
                errorElement.style.display = 'block';
                const msg1 = theme.language?.products_general_inv_msg_1 || 'Only';
                const msg2 = theme.language?.products_general_inv_msg_2 || 'left in stock';
                errorElement.innerHTML = msg1 + '&nbsp;' + maxInventory + '&nbsp;' + msg2;
                
                // Hide the message after 4 seconds
                setTimeout(() => {
                  if (errorElement) {
                    errorElement.style.display = 'none';
                  }
                }, 4000);
              }
              
                             // Don't call CartChange when inventory limit is hit - just show popup
               ev.preventDefault();
               ev.stopPropagation();
               return false;
            }
          }
        }
        
        // Update the input value BEFORE calling CartChange
        quantityInput.value = newQuantity;
        
        // Prevent any other handlers from running
        ev.preventDefault();
        ev.stopPropagation();
        
        CartChange(q,container);
        return false;
      }
    }, 1);
  })  
  
  var qI = container.querySelectorAll('.item-qty');
  qI.forEach(function(q) {
    let timeout;
    var vV = q.value,
        vM = q.getAttribute('max');
    
    // Check if this is an NPO restricted product
    var isNpoRestricted = q.getAttribute('data-npo-restricted') === 'true';
    
    q.addEventListener('keyup', async function (e) {
      if (e.key == 'Tab' || e.key == 'Shift') return;
      var nV = q.value;
      clearTimeout(timeout);
      timeout = setTimeout(async function () {
        // For NPO restricted products, validate BEFORE allowing cart change
        if (isNpoRestricted) {
          console.log(`[Cart] NPO restricted product (keyboard) - validating before cart change`);
          
          const newQuantity = parseInt(nV) || 0;
          const currentQuantity = parseInt(q.defaultValue) || 0;
          const productId = q.getAttribute('data-product-id');
          
          const validationResult = await validateQuantityChange(productId, newQuantity, currentQuantity);
          
          if (!validationResult.allowed) {
            console.log(`[Cart] BLOCKED (keyboard) - ${validationResult.reason}`);
            if (validationResult.message) {
              showToastNotification(validationResult.message, 'warning');
            }
            q.value = currentQuantity; // Keep current value
            return;
          }
          
          console.log(`[Cart] NPO validation passed (keyboard) - proceeding with cart change`);
        }
        
        // For non-NPO products, use original theme validation
        if (vM && vM == nV) {
          return;
        }
        
        // Proceed with cart change
        CartChange(q, container);
      }, 1000);
    });
  });
}

theme.CartPage = (function() {
  function CartPage(container) {
    var sectionId = container.getAttribute('data-section-id');
    var chk = container.getAttribute('data-check');
    var rct = container.getAttribute('data-recent');
    var rV = document.getElementById('recently-viewed');
    var rVP = document.getElementById('recently-viewed-placeholder');
    theme.cart = true;
    // Quantity(container); // REMOVED: Conflicts with NPO cart handlers
    if(chk == 'true'){      
      var nC = container.querySelector('[name="checkout"]');
      document.getElementById('cart-terms').onclick = function(ev){
        if (this.checked == true) {
          nC.classList.remove('outline');
          nC.removeAttribute('disabled');
          nC.setAttribute('aria-label', theme.language.cart_general_checkout);
          nC.value = theme.language.cart_general_checkout;
          nC.textContent = theme.language.cart_general_checkout;
        } else {
          nC.classList.add('outline');
          nC.setAttribute('disabled', true);
          nC.setAttribute('aria-label', theme.language.cart_general_agree);
          nC.value = theme.language.cart_general_agree;
          nC.textContent = theme.language.cart_general_agree;
        }
      };
    };
    CartButtons(container);
    if(rct == 'true'){
      function gPD (){
        const pD = JSON.parse(localStorage.getItem('rVP'));
        const rVH = []
        if (pD) {
          rV.classList.remove('hidden');          
          pD.forEach(function(item,i){
            rVH.push('id:' + item.pID);
          });
          const rB = rVH.join('%20OR%20');
          fetch(theme.routes_search_url + '?&type=product&q=' + rB)
          .then(response => response.text())
          .then(data => {   
            const parser = new DOMParser();
            const htmlDocument = parser.parseFromString(data, 'text/html');
            var rVD = document.querySelector('.recently-viewed');
            var cP = htmlDocument.documentElement.querySelector('.collection-products');
            rVP.remove();
            rVD.appendChild(cP);
            imageObserver();
            if (theme.settings.quickView) {
              Quick();
            };
            if (theme.settings.compare) {
              CompareProducts();
            };
            Swatches(container);
            if (theme.settings.cart) {
              var sI = htmlDocument.documentElement.querySelector('.search_page').getAttribute('data-section-id');
              Cart(container,sI);
              
              // 🔧 NPO FIX: Handle dynamically added restricted products on cart page
              // Since we're on the cart page, default all restricted products to VIP access
              const newRestrictedContainers = cP.querySelectorAll('.newsletter-priority-container[data-realtime-validation="true"]');
              if (newRestrictedContainers.length > 0) {
                console.log('[Cart Recently Viewed] Found', newRestrictedContainers.length, 'restricted products - defaulting to VIP access');
                newRestrictedContainers.forEach(container => {
                  // Hide loading state
                  const loadingDiv = container.querySelector('.newsletter-validation-loading');
                  if (loadingDiv) loadingDiv.style.display = 'none';
                  
                  // Show VIP access (add-to-cart buttons)
                  const vipDiv = container.querySelector('.vip-access-container');
                  if (vipDiv) vipDiv.style.display = 'block';
                  
                  // Hide other states
                  const signupDiv = container.querySelector('.newsletter-signup-container');
                  if (signupDiv) signupDiv.style.display = 'none';
                  const deniedDiv = container.querySelector('.access-denied-container');
                  if (deniedDiv) deniedDiv.style.display = 'none';
                  const subscriberDeniedDiv = container.querySelector('.subscriber-denied-container');
                  if (subscriberDeniedDiv) subscriberDeniedDiv.style.display = 'none';
                });
              }
            }
          }).catch(function (err) {
            console.log('!: ' + err);
          });
        }
      }    
      gPD();
    };
    if (Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  }
  return CartPage;
})();

})(); // Close the IIFE that wraps cartChangeInProgress